// extracted by mini-css-extract-plugin
export var container = "styles-module__container___TLxbc";
export var picture = "styles-module__picture___BmG7R";
export var containerBgImage = "styles-module__containerBgImage___zcOu7";
export var innerContainer = "styles-module__innerContainer___wJAXp";
export var badgeStarContainer = "styles-module__badgeStarContainer___lUDuZ";
export var badgeImage = "styles-module__badgeImage___Sp1Jh";
export var rating = "styles-module__rating___fFw5G";
export var starsImage = "styles-module__starsImage___elslI";
export var titleTop = "styles-module__titleTop___ktEnw";
export var trademark = "styles-module__trademark___GHWcN";
export var stores = "styles-module__stores___xd56v";
export var hoverAnimation = "styles-module__hoverAnimation___Tk3wR";